import { render, staticRenderFns } from "./PagesView.vue?vue&type=template&id=78ca9c45&scoped=true"
import script from "./PagesView.vue?vue&type=script&lang=js"
export * from "./PagesView.vue?vue&type=script&lang=js"
import style0 from "./PagesView.vue?vue&type=style&index=0&id=78ca9c45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ca9c45",
  null
  
)

export default component.exports